import moment from "moment-timezone";
import { useEffect, useState } from "react";

const CountUp = (props) => {
  // Depend on a primitive timestamp so a new moment object with the same
  // time (created on every parent render) doesn't restart the interval.
  const startTime = moment(props.start).valueOf();
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((tick) => tick + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return (
    <div style={{ ...props.style }}>
      {moment
        .utc(moment.duration(moment().diff(startTime)).asMilliseconds())
        .format("HH:mm:ss")}
    </div>
  );
};

export default CountUp;
